import { HttpContextToken } from "@angular/common/http"

export const API_ROUTES = {
    candidate_form_url: 'test/:test-id/candidate-form',
    assessment_page_url: 'test/:test-id/start'
}

export const APP_CONST = {
    candidate_form: 'candidate-form',
    test: 'test',
    max_tab_switch: 100
}

export const TOAST_CONFIGURATION = {
    success: 'success',
    failed: 'error',
    warning: 'warn',
    info: 'info'
}

export const QUESTION_TYPES = {
    multi_correct: 'MCQ_MULTIPLE_CORRECT',
    single_correct: 'MCQ_SINGLE_CORRECT'
}

export const TEST_CONST = {
    auth_header: 'Dummy xyz',
    auth_token: 'authToken',
    instruction_images: [
        'assets/instruction-image/nav.gif',
        'assets/instruction-image/review.gif',
        'assets/instruction-image/submit.gif'
    ]
}

export const SKIP_AUTH_INTERCEPTOR = new HttpContextToken<boolean>(() => false);
